import {  ConfigObj, DomHelpers, FeatureDetection, PubSub } from '../../utils'

// TODO: Refactor modifiers, Add selector constants, refactor methodology
const MODULE_NAME = 'ps-custom-dropdown'

const defaultOpts = {}


export default class CustomDropdown {
  constructor($el, opts) {
    this.$el = $el
    this.opts = ConfigObj.merge(defaultOpts, opts)
    this.$select = this.$el.querySelector('select')
    this.isOpen = false
  }

  init() {
    if (!this.$select) { return }
    // Add event listeners
    this.addEventListeners()

    if (FeatureDetection.device.isTouch() == false) {

      this.selectOptions = this.getOptions()
      this.$list = this.createList()
      this.$label = this.createLabel()

      // Add Label and Custom dropdown
      this.$el.appendChild(this.$label)
      this.$el.appendChild(this.$list)

      this.$select.setAttribute("style", "position: absolute; left: -99999px;")

      // keep '-is selected' class on Edit mode
      if (!this.selectOptions[0].isSelected) this.$label.classList.add('is-selected')

    } else {
      this.togglePlaceholder()
    }

    // keep select "active" class on Edit mode"
    this.activeSelect()
  }

  getOptions() {
    // Go through the select box options and the text and value from index 1
    return [...this.$select.options].map( opt => {
      return {
        text: opt.text,
        value: opt.value,
        isSelected: opt.selected
      }
    })
  }

  createList() {
    const $list = document.createElement('ul')

    $list.classList.add('ps-custom-dropdown__list')  // Creates a class for our new dropdowm UL

    // Creates the dropdown li with al the data from the Select Box
    this.getOptions().forEach(opt => {
      const $item = document.createElement('li')

      $item.classList.add('ps-custom-dropdown__element')

      if (opt.isSelected) $item.classList.add('active')
      $item.setAttribute('data-option-value', opt.value)
      $item.setAttribute('data-option-name', this.$select.name)

      if ($item.classList === 'active') return

      $item.innerText = opt.text
      $list.appendChild($item)

    })

    return $list
  }

  // Create the custom dropdown label 
  createLabel() {
    const $label = document.createElement('div')
    $label.classList.add('ps-custom-dropdown__label')
    $label.innerText = this.getActiveOption().text

    return $label
  }

  setActiveOption(e) {
    const value = !e.target || /select/i.test(e.target.nodeName)
      ? this.$select.value
      : e.target.dataset.optionValue

    const activeOption = this.selectOptions.filter( opt => opt.value == value )[0]
    const classAction = activeOption.value ? 'add' : 'remove';

    [...this.$select.options].forEach( opt => {
      opt.removeAttribute('selected')
      if (opt.value == value) return opt.setAttribute('selected', 'selected')
    })

    this.$label.innerText = activeOption.text
    this.$label.classList[classAction]('is-selected')
    this.$select.value = value
    this.hideDropDown()
    PubSub.publish('customdropdown:change', { target: e.target })
  }

  getActiveOption() {
    let activeOption = [...this.$select.options].filter( $opt => {
      if ($opt.getAttribute('selected')) return $opt
    })[0]

    if (!activeOption) activeOption = this.selectOptions[0]

    return activeOption
  }

  showDropDown() {
    if (this.isOpen) return this.hideDropDown()

    this.isOpen = true

    // add an active class to the label once clicked on - this is for styling purposes
    this.$label.classList.add('ps-active')
    this.$list.classList.add('ps-show')
  }

  hideDropDown() {
    if (!this.isOpen) return

    this.isOpen = false
    this.$label.classList.remove('ps-active')
    this.$list.classList.remove('ps-show')
    this.$select.blur()
  }

  //Close dropdown if user click anywhere on the page
  closeDropDown(e) {
    if (e.target != this.$label) {
      this.hideDropDown()
      //to remove focus on native select box - this is for validation error
      this.$select.blur()
    }
  }

  onClickBind(e) {
    DomHelpers.delegateEvent(e, '.ps-custom-dropdown__label', this.showDropDown.bind(this, e))
    DomHelpers.delegateEvent(e, '.ps-custom-dropdown__element', this.setActiveOption.bind(this, e))
  }

  // Add an active class to the native select dropdown for styling purposes
  activeSelect() {
    const action = this.$select.value != 0 ? 'add' : 'remove'
    this.$select.classList[action]('ps-active')
    this.$el.classList[action]('ps-active')
  }

  addEventListeners() {
    if (FeatureDetection.device.isTouch() == false) {
      // Opening the dropdown
      this.$el.addEventListener('click', this.onClickBind.bind(this))
      document.addEventListener('click', this.closeDropDown.bind(this))
      PubSub.subscribe('customdropdown:update', this.setActiveOption.bind(this))
    } else {
      PubSub.subscribe('customdropdown:update', this.togglePlaceholder.bind(this))
      PubSub.subscribe('customdropdown:update', this.activeSelect.bind(this))
    }
  }

  togglePlaceholder() {
    const action = this.$select.options[this.$select.selectedIndex].value ? 'add' : 'remove'
    // Add class active value if it's not default value
    this.$select.classList[action]('ps-active')
  }

}



// WEBPACK FOOTER //
// ./js/self-serve/modules/CustomDropdown.js